export interface CourseDmOverviewInterface {
  id?: string;
  name?: string;
  startDifficulty?: number;
  endDifficulty?: number;
  nextAppointmentDate?: Date;
}
